import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import CloseIcon from "../icons/cross.svg?react";

interface MatcheeInputProps {
  username: string;
  onClearUsername: () => void;
  className?: string;
}

const MatcheeInput: React.FC<MatcheeInputProps> = ({
  username,
  onClearUsername,
  className = "",
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleContainerClick = () => {
    if (!username) {
      navigate("/search");
    }
  };

  const handleClearClick = (event: React.MouseEvent) => {
    event.stopPropagation();
    onClearUsername();
  };

  const handleClearKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      event.stopPropagation();
      onClearUsername();
    }
  };

  const handleCameraClick = (event: React.MouseEvent) => {
    event.stopPropagation();
    navigate("/camera");
  };

  const handleCameraKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      event.stopPropagation();
      navigate("/camera");
    }
  };

  return (
    <>
      {!username ? (
        <div className="absolute left-1/2 top-1 -translate-x-1/2 -translate-y-1/2 w-[calc(100%-20px)] flex items-center px-1 py-1 gap-10">
          <span
            className={`whitespace-nowrap text-white border select-none font-bold border-[#00000020] text-md px-4 py-4 rounded-lg shadow uppercase cursor-pointer bg-sangati-green ${className} flex-1 text-center`}
            onClick={handleContainerClick}
            tabIndex={0}
            role="button"
            aria-label="Soul Market"
            onKeyDown={(event) => {
              if (event.key === "Enter" || event.key === " ") {
                event.preventDefault();
                handleContainerClick();
              }
            }}
          >
            Soul Market
          </span>
          <span
            className="w-8 h-8 cursor-pointer flex"
            onClick={handleCameraClick}
            tabIndex={1}
            role="button"
            aria-label="Open QR camera"
            onKeyDown={handleCameraKeyDown}
          >
            <img
              src="/icons/qr-code.png"
              alt="camera"
              className="w-full h-full"
            />
          </span>
        </div>
      ) : (
        <div
          className={`absolute left-1/2 top-1 -translate-x-1/2 -translate-y-1/2 bg-white border-[2px] border-[#00000020] rounded-[10px] w-[calc(100%-30px)] flex items-center justify-between px-4 py-[10px] gap-3 shadow-lg z-20 ${!username ? "pulse-matchee-input" : ""} ${className}`}
        >
          <div className="flex gap-2 items-center">
            <div className="w-5 h-5 rounded-sm border border-black bg-sangati-matchee" />
            <div className="flex items-center text-14 font-serif">
              <span className="text-neutral-grey">{t("sangatiLive")}/</span>
              <span className="text-black pl-[2px] select-none">
                {username}
              </span>
            </div>
          </div>

          <div className="absolute right-0 top-1 pr-2 bg-white">
            <div
              className="cursor-pointer"
              onClick={handleClearClick}
              tabIndex={0}
              role="button"
              aria-label="Clear match"
              onKeyDown={handleClearKeyDown}
            >
              <CloseIcon
                width={30}
                height={30}
                className="text-sangati-orange"
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default MatcheeInput;
